module.exports = __webpack_public_path__ + "static/media/th-large.6f46341c.svg";